// import { useTranslationContext } from "@providers/TranslationProvider";
import Exhibitions from "@components/Arts/Exhibitions";
import Overview from "@components/Arts/Overview";
import AllAround from "@components/Arts/AllAround";
import OurCollection from "@components/Arts/OurCollection";
import Spotlight from "@components/Arts/Spotlight";
import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import StayInspired from "@components/Home/StayInspired";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import helper, { artPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData, hotel } = usePageContext();
  const stories: any = {
    ...artPage.formatSpotlight(pageData),
  };
  const exhibitionData = artPage.formatExhibition(pageData);
  const exhibitions: any = {
    ...artPage.formatExhibition(pageData),
    upcomingExhibition: artPage.formatExhibitionArticles(
      exhibitionData.upcoming,
      "upcoming"
    ),
    currentExhibition: artPage.formatExhibitionArticles(
      exhibitionData.current,
      "current"
    ),
    previousExhibition: artPage.formatExhibitionArticles(
      exhibitionData.previous,
      "previous"
    ),
  };
  const banner = helper.formatBanner(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="bg-black" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        title={_.get(banner, "title", "")}
      />
      <Breadcrumbs
        data={router.breadcrumbs("arts", {})}
        mode="dark"
        className="bg-white"
      />

      <Overview />
      <OurCollection />
      {/* <FeaturedItem /> */}
      <AllAround />
      <Spotlight data={stories} />
      <Exhibitions data={exhibitions} />
      <StayInspired />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
        }}
      />
    </div>
  );
};

export default View;
